module.exports = __webpack_public_path__ + "static/media/beep-sound.487d0627.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/beep-sound.mp3
// module id = 24
// module chunks = 0